import { create } from 'zustand';

import { ApplyFindingStore } from './use-apply-finding.model';

export const useApplyFindingStore = create<ApplyFindingStore>((set) => ({
  applyFindings: {},
  setApplyFinding: (organ, question, loading) =>
    set((state) => ({
      applyFindings: {
        ...state.applyFindings,
        [organ]: {
          ...(state.applyFindings[organ] || {}),
          [question]: loading,
        },
      },
    })),
}));
